import { AccountStatus } from 'modules/common/components/AccountStatus';
import { BalanceCard } from 'modules/billing/components/BalanceCard';
import { GlobalMenuWrapper } from 'modules/globalMenu/components/GlobalMenuWrapper';
import { isSSG } from 'modules/common/utils/isSSG';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useIsSMDown } from 'uiKit/Theme/useTheme';
import { usePublicChainsRoutes } from 'domains/chains/hooks/usePublicChainsRoutes';
import { useSignOut } from 'modules/auth/hooks/useSignOut';

import { MainNavigation } from '../MainNavigation';
import { useStyles } from './SideBarStyles';
import { useTopBannersHeight } from '../TopBannersHeightProvider';

export interface SidebarProps {
  className?: string;
  handleSidebarClose?: () => void;
  hasMenu: boolean;
  isMobileSideBar?: boolean;
}

export const SideBar = ({
  className = '',
  handleSidebarClose,
  hasMenu,
  isMobileSideBar = false,
}: SidebarProps) => {
  const chainsRoutes = usePublicChainsRoutes();
  const { isLoggedIn } = useAuth();

  const { isSigningOut } = useSignOut();

  const { topBannersHeight } = useTopBannersHeight();

  const { classes, cx } = useStyles({ isMobileSideBar, topBannersHeight });

  const isMDDown = useIsSMDown();

  return (
    <aside className={cx(classes.root, className)}>
      {hasMenu && <GlobalMenuWrapper />}
      {isMDDown && !isSSG() && (
        <AccountStatus className={classes.accountStatus} />
      )}
      {isLoggedIn && !isSigningOut && (
        <BalanceCard
          className={classes.balanceCard}
          onButtonClick={handleSidebarClose}
        />
      )}
      <MainNavigation
        chainsRoutes={chainsRoutes}
        handleSidebarClose={handleSidebarClose}
        isMobileSideBar={isMobileSideBar}
        isSigningOut={isSigningOut}
      />
    </aside>
  );
};
